(function () {
  "use strict";

  // ——— money formatter ———
  const moneyFormat =
    window.Shopify && window.Shopify.money_format
      ? window.Shopify.money_format
      : "${{amount}}";
  function formatMoney(cents) {
    const n = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, n)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  }
  window.formatMoney = formatMoney;

  // ——— cart drawer ———
  const drawer = document.querySelector("[data-cart-drawer]");
  const overlay = document.querySelector("[data-cart-overlay]");

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("open");
    overlay && overlay.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("open");
    overlay && overlay.classList.remove("open");
    document.documentElement.style.overflow = "";
  }
  document.addEventListener("click", function (e) {
    const open = e.target.closest("[data-cart-open]");
    const close = e.target.closest("[data-cart-close]");
    if (open) {
      e.preventDefault();
      openDrawer();
      refreshCart();
    }
    if (close) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // ——— refresh cart contents ———
  async function fetchCart() {
    const res = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    return res.json();
  }
  function renderCart(cart) {
    const body = drawer && drawer.querySelector("[data-cart-body]");
    const footer = drawer && drawer.querySelector("[data-cart-footer]");
    const countEls = document.querySelectorAll("[data-cart-count]");
    countEls.forEach((el) => {
      el.textContent = cart.item_count;
    });

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="drawer-empty"><h4 class="serif">' +
        (window.SerenStrings.empty || "Nothing here yet.") +
        "</h4><p>" +
        (window.SerenStrings.empty_sub || "") +
        "</p>" +
        '<button class="btn btn-ink" style="margin-top:24px" data-cart-close onclick="window.location.href=\'/collections/all\'">' +
        (window.SerenStrings.start_shopping || "Start shopping") +
        "</button></div>";
      footer && (footer.style.display = "none");
      return;
    }
    footer && (footer.style.display = "");

    const items = cart.items
      .map(function (item) {
        const props = item.properties || {};
        const subBadge = item.selling_plan_allocation
          ? "Subscribe · " +
            (item.selling_plan_allocation.selling_plan.name || "")
          : "One-time";
        const img =
          item.featured_image && item.featured_image.url
            ? '<img src="' +
              item.featured_image.url +
              '" alt="' +
              (item.title || "") +
              '" />'
            : '<div class="ph"></div>';
        return (
          '<div class="cart-item" data-line-key="' +
          item.key +
          '">' +
          '<div class="cart-item-img">' +
          img +
          "</div>" +
          '<div class="cart-item-body">' +
          "<h5>" +
          item.product_title +
          "</h5>" +
          '<div class="meta">' +
          (item.variant_title && item.variant_title !== "Default Title"
            ? item.variant_title + " · "
            : "") +
          subBadge +
          "</div>" +
          '<div class="cart-item-qty">' +
          "<button data-line-decrement>−</button>" +
          "<span>" +
          item.quantity +
          "</span>" +
          "<button data-line-increment>+</button>" +
          "</div>" +
          "</div>" +
          "<div>" +
          '<div class="cart-item-price">' +
          formatMoney(item.final_line_price) +
          "</div>" +
          '<span class="cart-item-remove" data-line-remove>Remove</span>' +
          "</div>" +
          "</div>"
        );
      })
      .join("");

    const threshold =
      Number(
        (window.SerenSettings &&
          window.SerenSettings.free_shipping_threshold) ||
          45,
      ) * 100;
    const toFreeShip = Math.max(0, threshold - cart.items_subtotal_price);
    const progress = Math.min(
      100,
      (cart.items_subtotal_price / threshold) * 100,
    );

    const upsell =
      '<div class="drawer-upsell">' +
      '<div class="drawer-upsell-bar"><div style="width:' +
      progress +
      '%"></div></div>' +
      '<span class="mono">' +
      (toFreeShip > 0
        ? formatMoney(toFreeShip) + " to free ship"
        : "✓ Free shipping!") +
      "</span>" +
      "</div>";

    const subtotalRow =
      '<div class="drawer-row"><span>Subtotal</span><span>' +
      formatMoney(cart.items_subtotal_price) +
      "</span></div>" +
      '<div class="drawer-row"><span>Shipping</span><span>' +
      (toFreeShip > 0 ? "Calculated at checkout" : "Free") +
      "</span></div>" +
      '<div class="drawer-row total"><span>Total</span><span>' +
      formatMoney(cart.total_price) +
      "</span></div>" +
      '<form action="/cart" method="post"><button type="submit" name="checkout" class="btn btn-moss btn-block btn-lg">Checkout →</button></form>';

    body.innerHTML = items;
    if (footer) footer.innerHTML = upsell + subtotalRow;
  }
  async function refreshCart() {
    const cart = await fetchCart();
    renderCart(cart);
  }
  window.refreshCart = refreshCart;

  // ——— add to cart (forms with data-add-form) ———
  document.addEventListener("submit", async function (e) {
    const form = e.target.closest("[data-add-form]");
    if (!form) return;
    e.preventDefault();
    const formData = new FormData(form);
    const btn = form.querySelector("[type=submit]");
    const originalText = btn ? btn.textContent : "";
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Adding…";
    }
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });
      if (!res.ok) throw new Error(await res.text());
      await refreshCart();
      openDrawer();
    } catch (err) {
      console.error(err);
      alert("Couldn't add to cart. " + (err.message || ""));
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }
  });

  // ——— line item updates inside drawer ———
  document.addEventListener("click", async function (e) {
    const lineEl = e.target.closest("[data-line-key]");
    if (!lineEl) return;
    const key = lineEl.getAttribute("data-line-key");
    const qtyEl = lineEl.querySelector(".cart-item-qty span");
    const currentQty = parseInt(qtyEl ? qtyEl.textContent : "1", 10);

    let newQty = null;
    if (e.target.matches("[data-line-decrement]"))
      newQty = Math.max(0, currentQty - 1);
    if (e.target.matches("[data-line-increment]")) newQty = currentQty + 1;
    if (e.target.matches("[data-line-remove]")) newQty = 0;
    if (newQty === null) return;
    e.preventDefault();
    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity: newQty }),
    });
    await refreshCart();
  });

  // ——— accordions (data-accordion + data-accordion-item) ———
  document.addEventListener("click", function (e) {
    const trigger = e.target.closest("[data-accordion-trigger]");
    if (!trigger) return;
    const item = trigger.closest("[data-accordion-item]");
    if (!item) return;
    const group = item.closest("[data-accordion]");
    const isOpen = item.classList.contains("open");
    if (group && group.hasAttribute("data-accordion-single")) {
      group
        .querySelectorAll("[data-accordion-item].open")
        .forEach((it) => it.classList.remove("open"));
    }
    if (isOpen) item.classList.remove("open");
    else item.classList.add("open");
  });

  // ——— PDP gallery thumbs ———
  document.addEventListener("click", function (e) {
    const thumb = e.target.closest("[data-thumb]");
    if (!thumb) return;
    const idx = thumb.getAttribute("data-thumb");
    const gallery = thumb.closest("[data-gallery]");
    if (!gallery) return;
    gallery
      .querySelectorAll("[data-thumb]")
      .forEach((t) => t.classList.remove("active"));
    thumb.classList.add("active");
    gallery.querySelectorAll("[data-main-image]").forEach((img) => {
      img.classList.toggle(
        "is-hidden",
        img.getAttribute("data-main-image") !== idx,
      );
    });
  });

  // ——— PDP take-for hover ———
  document.addEventListener("mouseover", function (e) {
    const item = e.target.closest("[data-take-item]");
    if (!item) return;
    const list = item.closest("[data-take-list]");
    if (!list) return;
    list
      .querySelectorAll("[data-take-item]")
      .forEach((it) => it.classList.remove("active"));
    item.classList.add("active");
    const idx = item.getAttribute("data-take-item");
    const root = list.closest("[data-take-root]");
    if (root) {
      root.querySelectorAll("[data-take-image]").forEach((img) => {
        img.classList.toggle(
          "is-hidden",
          img.getAttribute("data-take-image") !== idx,
        );
      });
    }
  });

  // ——— PDP purchase + qty + selling plan ———
  document.addEventListener("click", function (e) {
    const opt = e.target.closest("[data-purchase-option]");
    if (opt) {
      const block = opt.closest("[data-purchase-block]");
      if (!block) return;
      block
        .querySelectorAll("[data-purchase-option]")
        .forEach((o) => o.classList.remove("active", "recommended"));
      opt.classList.add("active");
      if (opt.getAttribute("data-purchase-option") === "subscribe")
        opt.classList.add("recommended");
      const planInput = block.querySelector("[name='selling_plan']");
      const sellingPlan = opt.getAttribute("data-selling-plan");
      if (planInput) planInput.value = sellingPlan || "";
      // toggle prices visible
      block.querySelectorAll("[data-price-for]").forEach((p) => {
        p.classList.toggle(
          "is-hidden",
          p.getAttribute("data-price-for") !==
            opt.getAttribute("data-purchase-option"),
        );
      });
    }
    const qBtn = e.target.closest("[data-qty]");
    if (qBtn) {
      const wrap = qBtn.closest("[data-qty-wrap]");
      const input = wrap && wrap.querySelector("input[name='quantity']");
      const display = wrap && wrap.querySelector("[data-qty-display]");
      if (!input) return;
      const cur = parseInt(input.value || "1", 10);
      const next =
        qBtn.getAttribute("data-qty") === "+" ? cur + 1 : Math.max(1, cur - 1);
      input.value = next;
      if (display) display.textContent = next;
    }
  });

  // ——— FAQ tag filter (reviews page) ———
  document.addEventListener("click", function (e) {
    const tag = e.target.closest("[data-filter]");
    if (!tag) return;
    const wrap = tag.closest("[data-filter-wrap]");
    if (!wrap) return;
    const value = tag.getAttribute("data-filter");
    wrap
      .querySelectorAll("[data-filter]")
      .forEach((t) => t.classList.toggle("is-active", t === tag));
    const grid = document.querySelector("[data-review-grid]");
    if (!grid) return;
    grid.querySelectorAll("[data-review-tag]").forEach((card) => {
      const tags = (card.getAttribute("data-review-tag") || "").toLowerCase();
      card.classList.toggle(
        "is-hidden",
        value !== "all" && !tags.includes(value),
      );
    });
  });

  // ——— bundle builder ———
  function recomputeBundle() {
    const root = document.querySelector("[data-bundle]");
    if (!root) return;
    const cards = root.querySelectorAll("[data-bundle-card]");
    let totalQty = 0;
    let subtotal = 0;
    const lines = [];
    cards.forEach((card) => {
      const qty = parseInt(card.getAttribute("data-qty") || "0", 10);
      const price = parseInt(card.getAttribute("data-price") || "0", 10); // cents
      const title = card.getAttribute("data-title");
      const variantId = card.getAttribute("data-variant-id");
      if (qty > 0) {
        totalQty += qty;
        subtotal += qty * price;
        lines.push({ qty, price, title, variantId });
      }
    });
    const freqEl = root.querySelector("[data-bundle-freq].active");
    const freq = freqEl ? freqEl.getAttribute("data-bundle-freq") : "subscribe";
    const sellingPlanId = freqEl
      ? freqEl.getAttribute("data-selling-plan")
      : "";
    const bundleDiscount = totalQty >= 3 ? 0.1 : totalQty >= 2 ? 0.05 : 0;
    const subDiscount = freq === "subscribe" ? 0.15 : 0;
    const totalDiscount = bundleDiscount + subDiscount;
    const savings = subtotal * totalDiscount;
    const total = subtotal - savings;

    const summary = root.querySelector("[data-bundle-summary]");
    if (summary) {
      let html = "";
      if (totalQty === 0) {
        html +=
          '<div class="bundle-summary-line empty">Add mushrooms to get started.</div>';
      } else {
        lines.forEach((l) => {
          html +=
            '<div class="bundle-summary-line"><span>' +
            l.qty +
            "× " +
            l.title +
            "</span><span>" +
            formatMoney(l.qty * l.price) +
            "</span></div>";
        });
      }
      if (bundleDiscount > 0) {
        html +=
          '<div class="bundle-summary-line save"><span>Bundle discount (' +
          bundleDiscount * 100 +
          "%)</span><span>− " +
          formatMoney(subtotal * bundleDiscount) +
          "</span></div>";
      }
      if (subDiscount > 0 && totalQty > 0) {
        html +=
          '<div class="bundle-summary-line save"><span>Subscribe & save (15%)</span><span>− ' +
          formatMoney(subtotal * subDiscount) +
          "</span></div>";
      }
      html +=
        '<div class="bundle-summary-total">' +
        "<div>" +
        '<div class="lbl">Total today</div>' +
        '<div style="margin-top:4px"><span class="amt">' +
        formatMoney(total) +
        "</span>" +
        (savings > 0
          ? '<span class="old">' + formatMoney(subtotal) + "</span>"
          : "") +
        "</div>" +
        "</div>" +
        "</div>";
      const ctaLabel =
        totalQty === 0 ? "Pick a mushroom" : "Add bundle to cart";
      html +=
        '<button class="btn btn-cream btn-block btn-lg" data-bundle-add' +
        (totalQty === 0 ? " disabled" : "") +
        ">" +
        ctaLabel +
        "</button>";
      html +=
        '<p style="font-size:12px;color:rgba(244,237,224,0.6);margin-top:14px;text-align:center">Free shipping · 30-day guarantee · No codes needed</p>';
      summary.innerHTML = html;
    }
    root.setAttribute("data-bundle-selling-plan", sellingPlanId || "");
  }
  document.addEventListener("click", function (e) {
    const card = e.target.closest("[data-bundle-card]");
    const inc = e.target.closest("[data-bundle-qty]");
    if (inc && card) {
      e.preventDefault();
      e.stopPropagation();
      const cur = parseInt(card.getAttribute("data-qty") || "0", 10);
      const next =
        inc.getAttribute("data-bundle-qty") === "+"
          ? cur + 1
          : Math.max(0, cur - 1);
      card.setAttribute("data-qty", next);
      const qDisplay = card.querySelector("[data-qty-display]");
      if (qDisplay) qDisplay.textContent = next;
      const qLabel = card.querySelector("[data-qty-label]");
      if (qLabel)
        qLabel.textContent =
          next > 0 ? next + " bottle" + (next > 1 ? "s" : "") : "Add";
      card.classList.toggle("active", next > 0);
      recomputeBundle();
      return;
    }
    if (card && !inc) {
      const cur = parseInt(card.getAttribute("data-qty") || "0", 10);
      if (cur === 0) {
        card.setAttribute("data-qty", "1");
        card.classList.add("active");
        const qDisplay = card.querySelector("[data-qty-display]");
        if (qDisplay) qDisplay.textContent = "1";
        const qLabel = card.querySelector("[data-qty-label]");
        if (qLabel) qLabel.textContent = "1 bottle";
        recomputeBundle();
      }
    }
    const freq = e.target.closest("[data-bundle-freq]");
    if (freq) {
      const root = freq.closest("[data-bundle]");
      root
        .querySelectorAll("[data-bundle-freq]")
        .forEach((f) => f.classList.remove("active"));
      freq.classList.add("active");
      recomputeBundle();
    }
    const addBtn = e.target.closest("[data-bundle-add]");
    if (addBtn) {
      e.preventDefault();
      addBundleToCart();
    }
  });
  async function addBundleToCart() {
    const root = document.querySelector("[data-bundle]");
    if (!root) return;
    const sellingPlan = root.getAttribute("data-bundle-selling-plan") || "";
    const items = [];
    root.querySelectorAll("[data-bundle-card]").forEach((card) => {
      const qty = parseInt(card.getAttribute("data-qty") || "0", 10);
      const variantId = card.getAttribute("data-variant-id");
      if (qty > 0 && variantId) {
        const item = { id: variantId, quantity: qty };
        if (sellingPlan) item.selling_plan = sellingPlan;
        items.push(item);
      }
    });
    if (!items.length) return;
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: items }),
      });
      if (!res.ok) throw new Error(await res.text());
      await refreshCart();
      openDrawer();
    } catch (err) {
      console.error(err);
      alert("Couldn't add bundle to cart.");
    }
  }
  // initial bundle render
  document.addEventListener("DOMContentLoaded", function () {
    recomputeBundle();
  });
})();
